/**
 * description: 闪网路由管理页面
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Info = resolve => {
    import('@/components/info').then(module => {
        resolve(module)
    })
}

const VIP = resolve => {
    import('components/vip').then(module => {
        resolve(module)
    })
}

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: '/info/spot'
        },
        {
            path: '/login',
            name: '系统登录',
            component: () => import('@/components/system/login')
        },
        {
            path: '/forget',
            name: '忘记密码',
            component: () => import('@/components/system/forget')
        },
        {
            path: '/register',
            name: '注册',
            component: () => import('@/components/system/register')
        },
        {
            path: '/quota/approval',
            name: '额度审批',
            component: () => import('@/components/system/quota')
        },
        {
            path: '/info',
            name: '行情中心',
            component: Info,
            children: [
                {
                    path: 'spot',
                    name: '现货',
                    component: () => import('@/components/info/spot')
                },
                {
                    path: 'any-extract',
                    name: '随提',
                    component: () => import('@/components/info/any-extract')
                },
                {
                    path: 'cent-purchasing',
                    name: '集采',
                    component: () => import('@/components/info/cent-purchasing')
                },
                {
                    path: 'promotion',
                    name: '甩卖',
                    component: () => import('@/components/info/promotion')
                },
                {
                    path: 'promotion/detail',
                    name: '甩卖详情',
                    component: () => import('@/components/info/promotion/detail')
                },
                {
                    path: 'ad',
                    name: '广告',
                    component: () => import('@/components/info/ad_view')
                }
            ]
        },
        {
            path: '/vip',
            component: VIP,
            children: [
                {
                    path: 'market',
                    name: '行情',
                    component: () => import('@/components/vip/market')
                },
                {
                    path: 'market/detail',
                    name: '行情详细页',
                    component: () => import('@/components/vip/market/buy-detail')
                },
                {
                    path: 'market/confirm',
                    name: '行情确认页',
                    component: () => import('@/components/vip/market/buy-confirm')
                },
                {
                    path: 'order',
                    name: '我的订单',
                    component: () => import('@/components/vip/order/index')
                },
                {
                    path: 'order/detail',
                    name: '我的订单详情',
                    component: () => import('@/components/vip/order/order-detail')
                },
                {
                    path: 'sale/detail',
                    name: '转卖详情',
                    component: () => import('@/components/vip/order/sale-detail')
                },
                {
                    path: 'order/sale',
                    name: '订单转卖',
                    component: () => import('@/components/vip/order/order-sale')
                },
                {
                    path: 'order/sale/confirm',
                    name: '订单转卖确认',
                    component: () => import('@/components/vip/order/order-sale-confirm')
                },
                {
                    path: 'order/sale/confirm/detail',
                    name: '订单转卖确认详细页',
                    component: () => import('@/components/vip/order/order-sale-confirm-detail')
                },
                {
                    path: 'order/cancel',
                    name: '撤单',
                    component: () => import('@/components/vip/order/order-cancel')
                },
                {
                    path: 'offline/delivery',
                    name: '线下提货',
                    component: () => import('@/components/vip/order/offline-delivery')
                },
                {
                    path: 'offline/delivery/confirm',
                    name: '线下提货确认',
                    component: () => import('@/components/vip/order/offline-delivery-confirm')
                },
                {
                    path: 'offline/delivery/confirm/detail',
                    name: '线下提货详细页',
                    component: () => import('@/components/vip/order/offline-delivery-confirm-detail')
                },
                {
                    path: 'next/month/delivery',
                    name: '跨月随提',
                    component: () => import('@/components/vip/order/next-month-delivery')
                },
                {
                    path: 'goods',
                    name: '我的货物',
                    component: () => import('@/components/vip/goods/index')
                },
                {
                    path: 'goods/sale',
                    name: '我的货物卖出',
                    component: () => import('@/components/vip/goods/goods-sale')
                },
                {
                    path: 'goods/sale/confirm',
                    name: '我的货物卖出确认',
                    component: () => import('@/components/vip/goods/goods-sale-confirm')
                },
                {
                    path: 'goods/sale/confirm/detail',
                    name: '我的货物卖出确认详细页',
                    component: () => import('@/components/vip/goods/goods-sale-confirm-detail')
                },
                {
                    path: 'transfer/delivery',
                    name: '转随提订单',
                    component: () => import('@/components/vip/order/transfer-delivery')
                },
                {
                    path: 'account',
                    name: '我的账户',
                    component: () => import('@/components/vip/account')
                },
                {
                    path: 'bill',
                    name: '我的账户详细',
                    component: () => import('@/components/vip/account/account-bill')
                },
                {
                    path: 'deposit/left',
                    name: '可用账户详细',
                    component: () => import('@/components/vip/account/account-bill-deposit-left')
                },
                {
                    path: 'deposit/frozen',
                    name: '订单占用明细',
                    component: () => import('@/components/vip/account/account-bill-deposit-frozen')
                },
                {
                    path: 'deposit/supplement',
                    name: '订单充值明细',
                    component: () => import('@/components/vip/account/account-bill-deposit-supplement')
                },
                {
                    path: 'deposit/floating',
                    name: '浮盈亏明细',
                    component: () => import('@/components/vip/account/account-bill-deposit-floating')
                },
                {
                    path: 'statis',
                    name: '分析统计',
                    component: () => import('@/components/vip/account/account-statis')
                },
                {
                    path: 'statis/detail',
                    name: '分析统计详细页',
                    component: () => import('@/components/vip/account/account-statis-detail')
                },
                {
                    path: 'user/info',
                    name: '个人信息',
                    component: () => import('@/components/vip/account/account-user-info')
                },
                {
                    path: 'history',
                    name: '历史记录',
                    component: () => import('@/components/vip/account/account-history-info')
                },
                {
                    path: 'history/buy',
                    name: '历史买入详细记录',
                    component: () => import('@/components/vip/account/account-history-info-buy')
                },
                {
                    path: 'history/sell',
                    name: '历史转卖详细记录',
                    component: () => import('@/components/vip/account/account-history-info-sell')
                },
                {
                    path: 'history/delivery',
                    name: '历史提货详细记录',
                    component: () => import('@/components/vip/account/account-history-info-delivery')
                },
                {
                    path: 'update/login/password',
                    name: '修改登录密码',
                    component: () => import('@/components/vip/account/account-update-password')
                },
                {
                    path: 'update/trade/password',
                    name: '修改交易密码',
                    component: () => import('@/components/vip/account/account-update-password')
                }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js